export default __webpack_public_path__ + "static/media/vi.f195a506.svg";